import { Box } from "@mui/system";

import { ChartType } from "./oe-kpi-chart-card";

export const OeKpiChartTypeSwitch = ({
  setChartType,
  value,
}: {
  setChartType: React.Dispatch<React.SetStateAction<ChartType>>;
  value: ChartType;
}) => {
  const activeStyles = {
    background: "#003781",
    color: "white",
    border: "1px solid  #003781",
  };
  const inactiveStyles = {
    background: "white",
    color: "#003781",
    border: "1px solid  #003781",
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
      onClick={() => setChartType(value === "line" ? "bar" : "line")}
    >
      <Box
        sx={{
          padding: "8px",
          borderBottomLeftRadius: "4px",
          borderTopLeftRadius: "4px",
          ...(value === "line" ? activeStyles : inactiveStyles),
        }}
      >
        Line chart
      </Box>
      <Box
        sx={{
          padding: "8px",
          borderBottomRightRadius: "4px",
          borderTopRightRadius: "4px",
          ...(value === "bar" ? activeStyles : inactiveStyles),
        }}
      >
        Bar chart
      </Box>
    </Box>
  );
};
